// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Si0Q","range":"MonthRangeSwitch_range__31KI2","disabled":"MonthRangeSwitch_disabled__1JV-F"};